module.exports = __webpack_public_path__ + "img/Delete_btn.76bd8ec3.png";